import { useSyncExternalStore } from "react";
import type {
  ShellRuntime,
  ShellSessionSnapshot,
} from "@shared/host/shell-runtime";

const EMPTY_SHELL_SESSION_SNAPSHOT: ShellSessionSnapshot = {
  token: null,
  user: null,
  tenant: null,
  isAuthenticated: false,
};

export const useShellSessionSnapshot = (
  runtime: ShellRuntime | undefined,
  enabled: boolean,
): ShellSessionSnapshot | null => {
  return useSyncExternalStore(
    (listener) => {
      if (!enabled || !runtime?.capabilities.session) {
        return () => undefined;
      }

      return runtime.capabilities.session.subscribe(listener);
    },
    () => {
      if (!enabled || !runtime?.capabilities.session) {
        return EMPTY_SHELL_SESSION_SNAPSHOT;
      }

      return runtime.capabilities.session.getSnapshot();
    },
    () => EMPTY_SHELL_SESSION_SNAPSHOT,
  );
};
